<template>
	<!-- 涉旅安全事故发生情况-扣分列表 -->
	<div class="deduct_list">
		<div class="head">
			<div class="head_left flex flex-col">
				<div> {{ title }}</div>
				<div class="flex-row  text-12 text-[#999999] font-400" >
					<span> {{ areaName }}</span>
					<span class="ml-8">{{ quarterName }}</span>
				</div>
			</div>
			<div class="head_right">
				<p v-if="accidentList.length > 0 && isShowDeduction" class="score">
					{{ surplusScore }}
				</p>
				<!--  :class="isShowDeduction ? '' : 'noScore'"  -->
				<p v-if="accidentList.length == 0 || !isShowDeduction" class="noScore" >未扣分</p>
				<p class="percent">{{ accidentScore }}/{{ sumScore }}</p>
			</div>
		</div>
		<div class="save_list">
			<div v-if="accidentList.length > 0" class="list">
				<div class="list_top">
					<div class="total">共<span>{{ accidentList.length }}</span> 条扣分记录
					</div>
					<!-- <btnauth custype="apply" :year="year" :quarter="quarter">
						<van-button v-if="addAuth === 'OPERATION01'" @click="addSituation" class="add_btn" size="small" type="primary" color="#36B374"><span class="plus">+</span> <span>新增</span></van-button>
					</btnauth> -->
				</div>
				<div class="record_list">
					<div class="record_item" v-for="item in accidentList" :key="item.id" >
						<div>
							<div class="record_title">
								<span class="list_tit">{{ item.accidentName }}</span>
								<div class="sjdiv">
                                  <span v-if="item.audited == 0" class="status" >待审核</span>
								  <span v-if="item.audited == 1" class="deduct_score"  :class=" item.isExceed =='1' ? 'line_through' : ''" >-{{ (item.deduction / 100)+"分" }}</span>
								  <div v-if="item.isExceed == '1' && item.audited ==  1" class="ajfstatus">已达扣分上限</div>
								</div>
								
							</div>
                            <!-- 原型上没有这个字段，暂时隐藏 -->
							<!-- <div v-if="item.audited == 1" class="reason deal_reason">
								<span>扣分原因：</span>
								<span class="deal_desc">{{ item.deductionReason }}</span>
							</div> -->
							<div class="reason deal_reason">
								<span>事故级别：</span>
								<span class="deal_desc">{{ item.accidentLevelCN }}</span>
							</div>
							<div class="reason">
								<span>发生时间：</span>
								<span>{{ item.accidentTime }}</span>
							</div>
							<div class="reason deal_reason">
								<span>处理情况：</span>
								<span class="deal_desc">{{ item.accidentDesc }}</span>
							</div>
							<div class="see_more" @click="goDetail(item)">
								<span>查看详情</span>
								<img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="accidentList.length == 0" class="no_data">
				<div class="no_data_img">
					<img src="@/assets/appraise/ic_wuxingxi@2x.png" alt />
				</div>
				<div class="no_data_tip">
					<p>该州市未发生</p>
					<p>涉旅安全事故发生情况</p>
				</div>
				<!-- <div class="add_btn_box">
					<btnauth custype="apply" :year="year" :quarter="quarter">
						<van-button v-if="addAuth === 'OPERATION01'" @click="addSituation" class="add_btns" size="small" type="primary" color="#36B374"><span class="plus">+</span><span>新增</span></van-button>
					</btnauth>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import api from "@/service/modules/appraiseNew.js";
import commonAPI from "../../../utils/common";
import btnauth from "../appraiseNew/components/btnauth";
export default {
	components: {
		btnauth,
	},
	data() {
		return {
			title: "",
			dataList: [1],
			accidentList: [], // 涉旅安全事故列表
			accidentScore: 0, // 涉旅安全事故扣分总数
			// surplusScore: 10, // 涉旅安全事故剩余分数
			// 权限字段
			addAuth: "",
			updateAuth: "",
			deleteAuth: "",
			userAuthoirese: "",
			year: this.$route.query.year,
			quarter: this.$route.query.quarter,
			quarterName:this.$route.query.quarterName,
			areaName:this.$route.query.areaName,
			surplusScore: 0, // 涉旅安全事故剩余分数
			sumScore: 0, // 总数
		};
	},
	created() {
		const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
		const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU0401"); //涉旅安全事故
		// console.log("-----涉旅安全事故权限:", notifyobj);
		if (notifyobj) {
			const childList = notifyobj.operationType;
			if (childList && childList.length > 0) {
				// for (let i = 0; i < childList.length; i++) {
				// 拿任意 类型数据的按钮权限集合。
				this.addAuth = "";
				this.updateAuth = "";
				this.deleteAuth = "";
				this.userAuthoirese = "";
				// const btnList = childList[0].operationType;
				for (let j = 0; j < childList.length; j++) {
					if (childList[j].value === "OPERATION01") {
						this.addAuth = "OPERATION01"; //新增
					}
					if (childList[j].value === "OPERATION02") {
						this.updateAuth = "OPERATION02"; //编辑
					}
					if (childList[j].value === "OPERATION03") {
						this.deleteAuth = "OPERATION03"; //删除
					}
					if (childList[j].value === "OPERATION06") {
						this.userAuthoirese = "OPERATION06";
					}
				}

				// }
			}
		}
		this.initData();
	},
	computed: {
    /** 列表中是否有已审核的项，有已审核的项就显示扣分，不管扣分是否为 0 **/
		isShowDeduction() {
		    return this.accidentList.map((e) => e.audited).includes(1);
		},
	},
	methods: {
		initData() {
			this.title = "涉旅安全事故发生情况";
			this.querySaveList();
		},
		// 新增
		addSituation() {
			const { area, quarter, year } = this.$route.query;
			this.$router.push( `/appraise/addSituation?area=${area}&quarter=${quarter}&year=${year}` );
		},
		// 查看详情
		goDetail(item) {
			const { area, quarter, year } = this.$route.query;
			// this.$router.push(`/appraise/deductDetail?id=${item.id}`);
			this.$router.push({
				path: "/appraise/deductDetail",
				query: {
					id: item.id,
					area,
					quarter,
					year,
					updateAuth: this.updateAuth,
					deleteAuth: this.deleteAuth,
					userAuthoirese: this.userAuthoirese,
					isExceed: item.isExceed,
				},
			});
		},
		// 涉旅安全事故发生情况扣分列表
		querySaveList() {
			const { area, quarter, year } = this.$route.query;
			let params = {
				area,
				quarter,
				year,
			};
			api.querySaveList(params).then((res) => {
				if (res.ret === 0) {
					this.accidentList = res.data.resVO;
					this.accidentScore = (res.data.score / 100).toFixed(2);
					this.surplusScore =	"-" + (res.data.deduction / 100).toFixed(2); //原本只有一个小数点，做个记录
					this.sumScore = (res.data.sumScore / 100).toFixed(1);
				}
			});
		},
	},
};
</script>

<style scoped lang="less">
.deduct_list {
	height: 100%;
	background-color: #fbfbfb;
}
.head {
	display: flex;
	justify-content: space-between;
	padding: 0 12px;
	width: 100%;
	height: 96px;
	background-color: #fff;
}
.head_left {
	padding-top: 20px;
	width: 276px;
	color: #333;
	font-size: 20px;
	line-height: 28px;
	font-weight: bold;
}
.head_right {
	text-align: right;
	.score {
		padding: 22px 0 8px;
		color: #ff4d4d;
		font-size: 22px;
		line-height: 22px;
		font-weight: 500;

	}
	.noScore {
		padding: 22px 0 8px;
		color: #999;
		font-size: 22px;
		line-height: 22px;
		font-weight: 500;
	}
	.percent {
		font-size: 14px;
		font-weight: 500;
		color: #999;
	}
}
.save_list {
	padding: 0 12px;
	.list_top {
		display: flex;
		justify-content: space-between;
	}
	.add_btn {
		margin: 24px 0 12px;
		width: 70px;
    height: 30px;
    span {
        line-height: 30px;
      }
      .plus {
        padding-right: 3px;
        line-height: 28px;
        vertical-align: top;
      }
	}
	.total {
		margin: 32px 0 20px;
		font-size: 14px;
		font-weight: 400;
		color: #333;
		span {
			color: #ff8c19;
			font-weight: 500;
		}
	}
	.record_list {
		background: #fff;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
		border-radius: 3px;
	}
	.record_item {
		padding: 16px;
		border-bottom: 1px solid #eee;
		.record_title {
			display: flex;
			justify-content: space-between;
			margin-bottom: 12px;
			color: #333;
			font-size: 14px;
            font-weight: 500;
            .title {
                flex: 1;
            }
            .list_tit {
                flex: 1;
                line-height: 20px;
                text-overflow: ellipsis;
                white-space: nowrap;
				overflow: hidden;
				font-weight: bold;
            }
            .status,
            .deduct_score {
                width: 50px;
                text-align: right;
                font-size: 12px;
                color: #ff8c19;
            }
            .deduct_score {
                font-size: 16px;
                color: #ff4d4d;
            }
		}
		&:last-child {
			border: 0;
		}
		.reason {
			// margin-bottom: 4px;
			line-height: 20px;
			font-size: 12px;
			color: #666;
		}
		.see_more {
			padding-top: 8px;
			font-size: 12px;
			color: #36b374;
			img {
				margin-left: 2px;
				display: inline-block;
				width: 12px;
				height: 12px;
				vertical-align: top;
			}
		}
	}
}
.no_data {
	.no_data_img {
		padding: 72px 0 20px;
		img {
			margin: 0 auto;
			width: 74px;
			height: 62px;
		}
	}
	.no_data_tip {
		line-height: 22px;
		font-size: 14px;
		color: #999;
		text-align: center;
	}
	.add_btn_box {
		padding: 32px 0;
		background-color: transparent;
		text-align: center;
		.add_btns {
			width: 70px;
      height: 30px;
      span {
        line-height: 30px;
      }
      .plus {
        padding-right: 3px;
        line-height: 28px;
        vertical-align: top;
      }
		}
	}
}
.deal_desc {
	width: 257px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	word-break: break-all;
	line-height: 20px;
}
.deal_reason {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.line_through {
  text-decoration: line-through;
}
.sjdiv {
  text-align: right;
  position: relative;
}
.ajfstatus {
  display: inline-block;
  // margin-top: 9px;
  // margin-left: 6px;
  width: 85px;
  font-size: 12px;
  color: #ff8c19;
  // text-align: right;
  position: absolute;
  left: -45px;
  top: 20px;
}
</style>
